/* WAREHOUSY 2026 — interacciones del tema (header, buscador, menu movil, tabs, rieles, reveal) */
(function(){
  document.documentElement.classList.add('wh-js');
  var $ = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var lock = function(on){document.documentElement.style.overflow = on ? 'hidden' : '';};

  function initHeader(){
    var header = $('.wh-header');
    if(!header || header.dataset.whInit) return;
    header.dataset.whInit = '1';
    var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

    // mega menu: abre con hover en escritorio y con clic/teclado
    $$('.wh-nav__item[data-mega]').forEach(function(item){
      var t; var btn = $('.wh-nav__link', item);
      var open = function(){ clearTimeout(t); $$('.wh-nav__item.is-open').forEach(function(o){ if(o!==item) o.classList.remove('is-open'); }); item.classList.add('is-open'); btn.setAttribute('aria-expanded','true'); };
      var close = function(){ t = setTimeout(function(){ item.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); }, 140); };
      item.addEventListener('mouseenter', open); item.addEventListener('mouseleave', close);
      btn.addEventListener('click', function(e){ e.preventDefault(); item.classList.contains('is-open') ? (item.classList.remove('is-open'), btn.setAttribute('aria-expanded','false')) : open(); });
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ $$('.wh-nav__item.is-open').forEach(function(o){o.classList.remove('is-open');}); closeSearch(); closeDrawer(); } });

    // buscador
    var search = $('.wh-search');
    function openSearch(){ if(!search) return; search.classList.add('is-open'); lock(true); setTimeout(function(){ var i=$('input[type="search"]',search); i && i.focus(); }, 60); }
    function closeSearch(){ if(!search || !search.classList.contains('is-open')) return; search.classList.remove('is-open'); lock(false); }
    window.whCloseSearch = closeSearch;
    $$('[data-wh-search-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openSearch(); }); });
    $$('[data-wh-search-close]').forEach(function(b){ b.addEventListener('click', closeSearch); });
    search && search.addEventListener('click', function(e){ if(e.target===search) closeSearch(); });

    // drawer movil
    var drawer = $('.wh-drawer');
    function openDrawer(){ if(!drawer) return; drawer.classList.add('is-open'); lock(true); }
    function closeDrawer(){ if(!drawer || !drawer.classList.contains('is-open')) return; drawer.classList.remove('is-open'); lock(false); }
    window.whCloseDrawer = closeDrawer;
    $$('[data-wh-drawer-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });
    $$('[data-wh-drawer-close]').forEach(function(b){ b.addEventListener('click', closeDrawer); });

    // contador del carrito: se refresca cuando el carrito cambia (iCart / fetch del tema)
    var refresh = function(){ fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){ $$('.wh-cart-count').forEach(function(el){ el.textContent=c.item_count; el.setAttribute('data-count', c.item_count); }); }).catch(function(){}); };
    var _f = window.fetch;
    if(_f && !window.__whFetchWrapped){
      window.__whFetchWrapped = true;
      window.fetch = function(){ var u = arguments[0] && (arguments[0].url || arguments[0]); var p = _f.apply(this, arguments);
        if(typeof u==='string' && /\/cart\/(add|change|update|clear)/.test(u)) p.then(function(){ setTimeout(refresh, 250); });
        return p; };
    }
    document.addEventListener('cart:updated', refresh);
  }

  function initTabs(root){
    $$('[data-wh-tabs]', root).forEach(function(box){
      if(box.dataset.whInit) return; box.dataset.whInit='1';
      var tabs = $$('[role="tab"]', box), panels = $$('[role="tabpanel"]', box);
      tabs.forEach(function(tab, i){ tab.addEventListener('click', function(){
        tabs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
        panels.forEach(function(p){ p.hidden = true; });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected','true'); panels[i].hidden = false;
        var more = $('[data-wh-tab-more]', box); if(more && tab.dataset.url){ more.href = tab.dataset.url; }
      }); });
    });
  }

  function initRails(root){
    $$('[data-wh-rail]', root).forEach(function(wrap){
      if(wrap.dataset.whInit) return; wrap.dataset.whInit='1';
      var rail = $('.wh-rail', wrap); if(!rail) return;
      $$('[data-wh-rail-dir]', wrap).forEach(function(b){ b.addEventListener('click', function(){
        var visible = $$('.wh-tabpanel:not([hidden]) .wh-rail', wrap)[0] || rail;
        visible.scrollBy({left: (+b.dataset.whRailDir) * visible.clientWidth * .9, behavior:'smooth'});
      }); });
    });
  }

  function initReveal(root){
    var els = $$('.wh-reveal:not(.is-in)', root);
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  function initCollection(){
    $$('[data-wh-sort]').forEach(function(sel){
      if(sel.dataset.whInit) return; sel.dataset.whInit='1';
      sel.addEventListener('change', function(){ var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString(); });
    });
    $$('[data-wh-instock]').forEach(function(chk){
      if(chk.dataset.whInit) return; chk.dataset.whInit='1';
      chk.addEventListener('change', function(){ var u = new URL(location.href); u.searchParams.delete('page');
        if(chk.checked) u.searchParams.set('filter.v.availability','1'); else u.searchParams.delete('filter.v.availability');
        location.href = u.toString(); });
    });
  }

  function initAll(root){ initHeader(); initTabs(root); initRails(root); initReveal(root); initCollection(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); }); else initAll(document);
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); $$('.wh-reveal', e.target).forEach(function(x){x.classList.add('is-in');}); });
})();
